import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const section = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'xs',
});

export const sectionHeading = css({
  fontSize: 'md',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  margin: 0,
});

export const text = css({
  fontSize: 'md',
  color: 'hpxBlue500',
  lineHeight: '1.5',
  margin: 0,
  whiteSpace: 'pre-wrap',
});
